import styled from "styled-components";

export const Container = styled.div`
  width: 100vw;
  height: 100vh;
  display: grid;
  overflow-x: hidden;
  transition: all ease 0.3s;
`;

export const Main = styled.div`
  display: grid;
  grid-template-rows: 70px calc(100vh - 70px);
  background-color: ${({theme}) => theme["container"]};
`;

export const Grid = styled.div`
  display: grid;
  transition: all ease 0.3s;
  overflow-x: hidden;
`;

export const Content = styled.div`
  padding: 1rem;
  overflow-x: auto;
  &::-webkit-scrollbar {
    height: 8px;
    width: 8px;
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 5px;
    background: ${({theme}) =>
      theme["isDark"] ? "rgba(255, 255, 255, .15)" : "rgba(0, 0, 0, .15)"};
  }
`;
